module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-400-regular-bd8f6281c3215228ca1721f5175a233a.woff";